let menu = document.getElementById("menu");

window.addEventListener('scroll', (event) => {        
    if(document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
        menu.classList.add("show");
        menu.classList.remove("hide");
    }  else {
        menu.classList.add("hide");
    } 
});